export function createBaseContext() {
  return {
    menuToggle: null,
    menuPanel: null,
    menuClose: null,
    menuLinks: [],
    menuProductLinks: [],
    menuPanelImage: null,
    header: null,
    heroTitleLines: [],
    heroSubtitle: null,
    heroProducts: [],
    detailSection: null,
    detailSegments: [],
    detailTitle: null,
    detailDescription: null,
    ecommerceSection: null,
    ecommerceText: null,
    ecommerceMedia: null,
    ecommerceCTA: null,
    ecommerceSlidesWrapper: null,
    ecommerceSlides: [],
    ecommerceProgressTrack: null,
    ecommerceProgressCurrent: null,
    ecommerceProgressTotal: null,
    ecommerceScrollTimeline: null,
    blogSliderSection: null,
    blogSliderTitle: null,
    blogSliderNav: null,
    blogSliderTrack: null,
    ecoSliderSection: null,
    ecoSliderTrack: null,
    ecoSliderControls: null,
    ecoSliderInstance: null,
    blogSliderInstance: null,
    lenisInstance: null,
    menuTimeline: null,
    showroomModal: null,
  };
}
